export default __webpack_public_path__ + "img/info.54a84b6c.svg";